import Catalog from './Catalog/store/state';
import Shippers from './Shippers/store/state';
import Products from './Products/store/state';
import Suppliers from './Suppliers/store/state';
import Attributes from './Attributes/store/state';
import Supplies from './SuppliedGoods/store/state';
import SuppliersGroup from './SupplierGroup/store/state';

export default {
  namespaced: true,
  modules: {
    Catalog,
    Attributes,
    Shippers,
    SuppliersGroup,
    Suppliers,
    Products,
    Supplies,
  },
};
